/* eslint-disable no-underscore-dangle */
import { Drawer, Switch, Typography } from 'antd';
import { useCallback, useContext } from 'react';
import { BaseLayerConfig } from 'types/app.types';
import BaseLayerContext from 'contexts/BaseLayerContext';
import baseLayers, { getFilteredBaseLayers } from 'configs/baseLayers';
import { LAYER_KEY_NAME, VirtualLayer, virtualLayers } from 'configs/virtualLayers';
import MainAppContext from 'contexts/MainAppContext';
import { BASE_LAYER_PROVIDER } from 'configs/endpoints';
import styles from './index.module.scss';
import LayerName from '../../../../../../../../contexts/MapViewContext/hooks/enums';

interface SettingsDrawerProps {
  open: boolean,
  onClose: () => void
}

const {
  wrapper, layer, title,
} = styles;

function SettingsDrawer({ open, onClose } : SettingsDrawerProps) {
  const { selectedBaseLayers, addBaseLayer, removeBaseLayer } = useContext(BaseLayerContext);
  const {
    displayAlarms, setDisplayAlarms, setAdsbIsEnabled,
    adsbIsEnabled,
  } = useContext(MainAppContext);
  const showAlarmsSwitch = (window as any)._env_.REACT_APP_SHOW_AAD_WIDGET_SWITCH === 'true';

  const handleOnChange = (checked : boolean, layer: BaseLayerConfig) => {
    if (checked) {
      addBaseLayer(layer);
    } else {
      removeBaseLayer(layer);
    }
  };

  const handleVirtualLayerEnabled = (checked : boolean, layer: VirtualLayer) => {
    if (layer.layerName === LAYER_KEY_NAME.ADS_B) {
      setAdsbIsEnabled(checked);
    }
  };

  const getLayers = useCallback(() => getFilteredBaseLayers(), []);

  return (
    <Drawer
      title="Settings"
      open={open}
      onClose={onClose}
      width="25vw"
    >
      <div className={wrapper}>
        <Typography.Text strong className={title}>Base Layers</Typography.Text>
        {getLayers().label?.map((baseLayer: BaseLayerConfig) => {
          const isOSMLabelsToggle = BASE_LAYER_PROVIDER === 'osm'
            && baseLayer.layerName === LayerName.BaseMapLayerWithLabels;
          return (
            <div className={layer} key={baseLayer.level}>
              <Typography.Text>
                {baseLayer.name}
              </Typography.Text>
              <Switch
                disabled={isOSMLabelsToggle}
                onChange={(checked) => {
                  if (baseLayer.layerName === LayerName.Coastline) {
                    localStorage.setItem('isCoaslineLayerEnabled', String(checked));
                  }
                  handleOnChange(checked, baseLayer);
                }}
                checked={isOSMLabelsToggle
                  ? selectedBaseLayers.some((l) => l.layerName === LayerName.BaseMapLayer)
                  : selectedBaseLayers.some((l) => l.level === baseLayer.level)}
              />
            </div>
          );
        })}
        <Typography.Text strong className={title}>Auxiliary layers</Typography.Text>
        {getLayers().aux?.map((baseLayer: BaseLayerConfig) => (
          <div className={layer} key={baseLayer.level}>
            <Typography.Text>
              {baseLayer.name}
            </Typography.Text>
            <Switch
              onChange={(checked) => {
                if (baseLayer.layerName === LayerName.ARENALayer) {
                  localStorage.setItem('isARENALayerEnabled', String(checked));
                }
                if (baseLayer.layerName === LayerName.CTRLayer) {
                  localStorage.setItem('isCTRLayerEnabled', String(checked));
                }
                if (baseLayer.layerName === LayerName.FIRLayer) {
                  localStorage.setItem('isFIRLayerEnabled', String(checked));
                }
                handleOnChange(checked, baseLayer);
              }}
              checked={selectedBaseLayers.some((l) => l.level === baseLayer.level)}
            />
          </div>
        ))}

        <Typography.Text strong className={title}>Tools</Typography.Text>
        {/** Change "display: none" style to see virtual layers */}
        {virtualLayers.map((vLayer: VirtualLayer) => (
          <div className={layer} key={baseLayers.length + 1 + vLayer.level}>
            <Typography.Text>{vLayer.name}</Typography.Text>
            <Switch
              checked={adsbIsEnabled}
              onChange={(checked) => handleVirtualLayerEnabled(checked, vLayer)}
            />
          </div>
        ))}
        {showAlarmsSwitch && (
          <div className={layer}>
            <Typography.Text>Show AAD Widget</Typography.Text>
            <Switch
              checked={displayAlarms}
              onChange={(checked) => setDisplayAlarms(checked)}
            />

          </div>
        )}
        {/* <div className={title}>Available Projections</div>
        <Select
          style={{ width: '100%' }}
          value={currentProjection}
          options={availableProjections
            .map((projection) => ({ label: projection.title, value: projection.name }))}
          onChange={(value) => { setCurrentProjection(value); }}
        /> */}
      </div>
    </Drawer>
  );
}

export default SettingsDrawer;
